import { render, staticRenderFns } from "./PostInvite.vue?vue&type=template&id=492425c8&scoped=true&"
import script from "./PostInvite.vue?vue&type=script&lang=js&"
export * from "./PostInvite.vue?vue&type=script&lang=js&"
import style0 from "./PostInvite.vue?vue&type=style&index=0&id=492425c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492425c8",
  null
  
)

export default component.exports